import { DnaProfileSearchDto, MarkerAllelesSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

const MarkerAllelesSchema: Yup.SchemaOf<MarkerAllelesSearchDto> = Yup.object({
    markerName: Yup.string().optional(),
    allele1: Yup.string().optional(),
    allele2: Yup.string().optional(),
});

export const DnaProfileSearchSchema: Yup.SchemaOf<DnaProfileSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    andeSwabId: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { collectionDate, collectedBy, kitId, markers } = this.parent;
            const hasMarkerData = markers && Object.keys(markers).some(key => 
                markers[key]?.allele1 || markers[key]?.allele2
            );
            return !!value || !!collectionDate || !!collectedBy || !!kitId || hasMarkerData;
        }
    ),
    collectionDate: Yup.date().optional().nullable().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { andeSwabId, collectedBy, kitId, markers } = this.parent;
            const hasMarkerData = markers && Object.keys(markers).some(key => 
                markers[key]?.allele1 || markers[key]?.allele2
            );
            return !!value || !!andeSwabId || !!collectedBy || !!kitId || hasMarkerData;
        }
    ) as any,
    collectedBy: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { andeSwabId, collectionDate, kitId, markers } = this.parent;
            const hasMarkerData = markers && Object.keys(markers).some(key => 
                markers[key]?.allele1 || markers[key]?.allele2
            );
            return !!value || !!andeSwabId || !!collectionDate || !!kitId || hasMarkerData;
        }
    ),
    kitId: Yup.number().optional().nullable().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { andeSwabId, collectionDate, collectedBy, markers } = this.parent;
            const hasMarkerData = markers && Object.keys(markers).some(key => 
                markers[key]?.allele1 || markers[key]?.allele2
            );
            return !!value || !!andeSwabId || !!collectionDate || !!collectedBy || hasMarkerData;
        }
    ),
    markers: Yup.lazy((obj) => 
        Yup.object(
            Object.keys(obj || {}).reduce((acc, key) => {
                acc[key] = MarkerAllelesSchema;
                return acc;
            }, {} as any)
        ).nullable()
    ) as any,
});
